import Hero from './sections/Hero';
import QuestionTypes from './sections/QuestionTypes';
import QuizHowItWorks from './sections/HowItWorks';
import QuizFeatures from './sections/Features';

const InteractiveQuizzes = () => {
  return (
    <>
      <Hero />
      <QuestionTypes />
      <QuizHowItWorks />
      <QuizFeatures />
    </>
  );
};

export default InteractiveQuizzes;
